jQuery(function($){
    
    $('#user_login').attr('placeholder', kreenoot_child.usernamePlaceholder);
    $('#user_pass').attr('placeholder', kreenoot_child.passwordPlaceholder);
  
});